import React, { useContext, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import './css/menu.css';
import './css/onprinttoggle.css';
import Image from 'react-bootstrap/Image';
import Logo from '../../margretlogo.png';

const Menu = () => {
    const location = useLocation();

    return (
        <div className="usr_menu print_hide">
            <br />
            <center><Image src={Logo} style={{ width: 80, height: 90 }} /></center>
            <center><h6>خەرجی و داهاتی رادیۆ </h6></center>
            <ul>
                <Link to="/radio/"><li className={location.pathname == '/radio/' ? 'aactive' : null}>داهات</li></Link>
                <Link to="/radio/expense"><li className={location.pathname == '/radio/expense' ? 'aactive' : null}>خەرجی</li></Link>
                <Link to="/radio/income_report"><li className={location.pathname == '/radio/income_report' ? 'aactive' : null}>ڕاپۆرتی داهات</li></Link>
                <Link to="/radio/expense_report"><li className={location.pathname == '/radio/expense_report' ? 'aactive' : null}>ڕاپۆرتی خەرجی</li></Link>
                <Link to="/radio/report"><li className={location.pathname == '/radio/report' ? 'aactive' : null}>ژمێریاری گشتی</li></Link>
            </ul>
        </div>
    )
}

export default Menu